/**
 * Shared CSS keyframes for the PublicDemo scenes.
 * Injected once at the top level of <PublicDemo>. Extracted to a module so
 * every scene doesn't inline its own <style> block.
 */
export const DEMO_KEYFRAMES = `
  @keyframes pd-progress { from { transform: scaleX(0);} to { transform: scaleX(1);} }
  @keyframes pd-fadein { from { opacity:0; transform: translateY(12px);} to { opacity:1; transform: translateY(0);} }
  @keyframes pd-fadein-slow { from { opacity:0; transform: translateY(20px);} to { opacity:1; transform: translateY(0);} }
  @keyframes pd-glow { 0%,100% { filter: drop-shadow(0 6px 18px rgba(16,185,129,0.25));} 50% { filter: drop-shadow(0 10px 36px rgba(16,185,129,0.45));} }
  @keyframes pd-pop { 0% { transform: scale(0.6); opacity: 0;} 70% { transform: scale(1.05); opacity:1;} 100% { transform: scale(1);} }
  @keyframes pd-count { 0% { transform: scale(1);} 30% { transform: scale(1.06);} 100% { transform: scale(1);} }
  @keyframes pd-ring { 0% { box-shadow: 0 0 0 0 rgba(16,185,129,0.55);} 100% { box-shadow: 0 0 0 18px rgba(16,185,129,0);} }
  @keyframes pd-apply-flash { 0%,100% { box-shadow: 0 0 0 0 rgba(16,185,129,0); } 35% { box-shadow: 0 0 0 8px rgba(16,185,129,0.35); } }
  @keyframes pd-red-pulse { 0%,100% { box-shadow: 0 0 0 0 rgba(244,63,94,0.55);} 50% { box-shadow: 0 0 0 12px rgba(244,63,94,0);} }
  @keyframes pd-slow-pulse { 0%,100% { transform: scale(1);} 50% { transform: scale(1.05);} }
  /* Ken-Burns pan + zoom */
  @keyframes kb-pan {
    0%   { transform: translateX(var(--kb-x-from, 0)) scale(1);                    }
    100% { transform: translateX(var(--kb-x-to,   0)) scale(var(--kb-zoom, 1.08)); }
  }
  /* Caption entrance */
  @keyframes cap-in {
    from { opacity: 0; transform: translateY(14px); }
    to   { opacity: 1; transform: translateY(0);    }
  }
`;
